import { Box } from '@wix/design-system';
import React, { PropsWithChildren } from 'react';

export const BulkActionContainer = ({ children }: PropsWithChildren<{}>) => {
  const ref = React.useRef<HTMLDivElement>(null);

  return (
    <Box ref={ref} minWidth="90px" direction="vertical">
      {children}
    </Box>
  );
};
